'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ../~/supporticon/~/axios/lib/cancel/isCancel.js
// module id = 495
// module chunks = 0